import { FormattedMessage } from "react-intl";
import { Status } from "../../enums/status";
import { AddressType, InventoryType } from "../../enums/types";
import { HeadCheck } from "./CustomElements";
import { IOrderStatus } from "../../interfaces/orders";

export function transformToCheckFactory<T = any>(
  onChange: React.InputHTMLAttributes<HTMLInputElement>["onChange"],
) {
  return function transformToCheck(value: string, obj: T) {
    return <HeadCheck onChange={onChange} value={value} />;
  };
}

export function transformToStatus(value: keyof typeof Status) {
  return (
    <span className={`tb-status text-${Status[value]?.class || "secondary"}`}>
      {Status[value]?.text || " - "}
    </span>
  );
}

export function transformToInventoryType(value: keyof typeof InventoryType) {
  return (
    <span className={`text-${InventoryType[value]?.class || "secondary"}`}>
      <em className={`${InventoryType[value]?.icon} me-1`} />
      {InventoryType[value]?.text || " - "}
    </span>
  );
}

export function transformToOrderStatus(status: IOrderStatus) {
  return (
    <>
      <span className={`dot bg-${status?.color || "secondary"} d-sm-none`} />
      <span
        className={`badge badge-sm badge-dot has-bg bg-${status?.color || "secondary"} d-none d-sm-inline-flex`}
      >
        {status?.description || " - "}
      </span>
    </>
  );
}

export function transformToAddressType(value: keyof typeof AddressType) {
  return (
    <>
      <span
        className={`dot bg-${AddressType[value]?.class || "secondary"} d-sm-none`}
      />
      <span
        className={`badge bg-${AddressType[value]?.class || "secondary"} d-none d-sm-inline-flex`}
      >
        <i className={AddressType[value]?.icon + " me-1"} />
        <FormattedMessage id={AddressType[value]?.text} />
      </span>
    </>
  );
}
